import { render, staticRenderFns } from "./TypeOfContent.vue?vue&type=template&id=02fc2673&"
import script from "./TypeOfContent.vue?vue&type=script&lang=js&"
export * from "./TypeOfContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports